import classNames from 'classnames';
import { useCallback } from 'react';
import { Button, Flex, useIsMobile } from 'yoso';
import { breakpoints } from '~/components/Breakpoint/Breakpoint.hook';
import { Header } from '~/components/Header';
import styles from '~/components/Header/Header.module.scss';
import { Close } from '~/components/Icon/Close';

export type CloseButtonHeaderProps = {
  className?: string;
};

export const CloseButtonHeader = ({ className }: CloseButtonHeaderProps) => {
  const isMobile = useIsMobile(undefined, breakpoints.medium);
  const onDismiss = useCallback(() => {
    history.back();
  }, []);
  return isMobile ? (
    <div className={classNames(styles.root, 'header', className)}>
      <Flex className={styles.inner} container alignItems="center" justifyContent="flex-end">
        <div className={styles.right}>
          <Button className={styles.button} variant="transparent" onClick={onDismiss}>
            <Close display="block" />
          </Button>
        </div>
      </Flex>
    </div>
  ) : (
    <Header />
  );
};
